import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link} from "react-router-dom";
import LoaderComponent from "../basic/loader";
import {useTranslation} from "react-i18next";

function ServicesApi(){

    const { t, i18n } = useTranslation()

    const STORAGE_URL = 'https://storage.lukyanchuk.com';

    const API_URL = 'https://api.lukyanchuk.com/api/v1/public/data/services?sort=DESC';

    const [data, setData] = useState([]);

    useEffect(() => {

        axios.get(API_URL, {}).then( response => {

            setData(response.data.data)

        }).catch(e => console.log(e.message))

    }, [])

    if(data === null){
        return <LoaderComponent
            text={''}
            smallText={'Services'}
        />;
    }

    return (<>
        {
            data && data.map((e, i) => e.image !== null &&
                <div className="col-md-4 col-12 p-2">
                    <Link to={e.url} target={'_blank'} className={'text-decoration-none'}>
                        <div className="service-item hover-div border1 rounded-5 blog-post-cover-">
                            <img
                                src={STORAGE_URL + '/storage/files/services/' + e.image}
                                alt="support" className={'img-fluid'}/>
                        </div>
                        <small className="text-secondary">
                            <svg className="w-6 h-6 text-gray-800 dark:text-white m-2" aria-hidden="true"
                                 xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                 viewBox="0 0 24 24">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                      stroke-width="2" d="M19 12H5m14 0-4 4m4-4-4-4"/>
                            </svg>
                            <span className={'lead'}>{i18n.language === 'en' ? e.name.en : e.name.ua}</span>
                        </small>
                    </Link>
                </div>
            )
        }
    </>);
}

export default ServicesApi;
